import { render, staticRenderFns } from "./perfectInformation-edit.vue?vue&type=template&id=6350ac4c&scoped=true"
import script from "./perfectInformation-edit.vue?vue&type=script&lang=js"
export * from "./perfectInformation-edit.vue?vue&type=script&lang=js"
import style0 from "./perfectInformation-edit.vue?vue&type=style&index=0&id=6350ac4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350ac4c",
  null
  
)

export default component.exports